import { FileReader, FileWriter } from '@/platform'

class UniteVar {
    /**
     * 内容名称
     */
    public Name: string = ''

    /**
     * 变量类型 1.字符串 2.数值
     */
    public TypeIndex: number = 0

    /**
     * 变量值索引
     */
    public VarIndex: number = 0

    public constructor(name: string = '', typeindex: number = 0, varindex: number = 0) {
        this.Name = name
        this.TypeIndex = typeindex
        this.VarIndex = varindex
    }

    readBin(reader: FileReader): void {
        this.Name = reader.readString()
        this.TypeIndex = reader.readInt()
        this.VarIndex = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        writer.writeInt(this.TypeIndex)
        writer.writeInt(this.VarIndex)
    }

    readVersionedOui(reader: FileReader): void {
        this.Name = reader.readString()
        this.TypeIndex = reader.readInt()
        this.VarIndex = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeString(this.Name)
        writer.writeInt(this.TypeIndex)
        writer.writeInt(this.VarIndex)

        writer.writerLength()
    }
}
export default UniteVar
